










































































































import {
  Component,
  Vue,
  PropSync,
  Emit,
  Prop,
  Watch,
} from "vue-property-decorator";
import { AnalysisProperties } from "./types";
import { Farm } from "@/api/farms/types";
import { AvailabilityDTO } from "@/api/products/types";

@Component({
  name: "AnalysisModal",
})
export default class AnalysisModal extends Vue {
  @PropSync("open", { type: Boolean, default: false })
  private stateSynced!: boolean;

  @Prop({ type: Object, required: false })
  private farm!: Farm | null;

  @Prop({ type: String, required: false })
  private analysisType!: string | null;

  private cropType = "";

  @Prop({ type: Array, required: true })
  private products!: AvailabilityDTO[]

  private period: number[] = []

  private monitoringYear = new Date().getFullYear()

  private label(year:number) {
    if (this.analysisType == "SENTINELA") {
      return `${year}`
    }
    return `${year - 1}/${year}`
  }

  private get availableProducts() {
    return this.products.filter(it => this.analysisType === it.analysisType)
  }

  get cropTypesToSelect() {
    return this.availableProducts.map(it => it.cropType)
  }

  private get periodToSelect() {
    const product = this.availableProducts.find(it => this.cropType === it.cropType)
    if (!product || !product.years) {
      return []
    }
    return product.years.map(it => ({ value: it, label: this.label(it) }))
  }

  // SOY é o padrão; se não estiver disponível para o tipo de análise, usa o primeiro produto disponível
  private defaultCropType() {
    const cropTypes = this.cropTypesToSelect
    if (cropTypes.includes("SOY")) {
      return "SOY"
    }
    return cropTypes.length > 0 ? cropTypes[0] : ""
  }

  @Watch("analysisType", { immediate: true })
  private resetCropType() {
    this.cropType = this.defaultCropType()
    this.verifyCroptype()
  }

  @Watch("cropType")
  private verifyCroptype() {
    const periods = this.periodToSelect
    this.period = periods.map((it) => it.value)
    this.monitoringYear = periods.length > 0 ? periods[0].value : new Date().getFullYear()
  }

  public confirmCreateAnalysis() {
    switch (this.analysisType) {
      case "ANALITICA":
        if (this.period.length > 0) {
          const analysisAux = {
            farm: this.farm,
            summerCulture:
              this.cropType === "SOY" || this.cropType === "SUGARCANE"
                ? this.cropType
                : null,
            winterCulture: this.cropType === "CORN" ? this.cropType : null,
            analysisType: this.analysisType,
            period: this.period,
            monitoring: this.monitoringYear,
          } as AnalysisProperties;

          this.$emit("onsubmit", analysisAux);
          this.period = [];
        }
        break;
      case "SENTINELA":
        const analysisAux = {
          farm: this.farm,
          summerCulture:
            this.cropType === "SOY" || this.cropType === "SUGARCANE"
              ? this.cropType
              : null,
          winterCulture: this.cropType === "CORN" ? this.cropType : null,
          analysisType: this.analysisType,
          period: this.period,
          monitoring: this.monitoringYear,
        } as AnalysisProperties;

        this.$emit("onsubmit", analysisAux);
        break;
    }
  }

  @Watch("open")
  public restart() {
    this.resetCropType();
  }

  @Emit("oncancel")
  public closeCreateAnalysis() {
    this.resetCropType();
  }
}
